import React, { useLayoutEffect } from 'react';
import styled from 'styled-components';
import Hero from '../components/Sections/Hero';
import ClientLogos from '../components/Sections/ClientLogos';
import Services from '../components/Sections/Services';
import FundingTeaser from '../components/Sections/Funding';
import About from '../components/Sections/About';
import Projects from '../components/Sections/Projects';
import Contact from '../components/Sections/Contact';

const HomeContainer = styled.main`
  padding-top: 80px; // Space for fixed navbar
`;

const Home: React.FC = () => {
  useLayoutEffect(() => {
    // Check if there's a hash in the URL and scroll to it after page load
    const hash = window.location.hash;
    if (hash) {
      const sectionId = hash.substring(1);
      
      const scrollToSection = () => {
        const element = document.getElementById(sectionId);
        if (element) {
          // Scroll to top first, then to the element
          window.scrollTo(0, 0);
          setTimeout(() => {
            element.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start',
              inline: 'nearest'
            });
            // Clear the hash after scrolling
            window.history.replaceState({}, document.title, window.location.pathname);
          }, 100);
        }
      };

      // Use a more reliable approach with multiple attempts
      let attempts = 0;
      const maxAttempts = 10;
      
      const tryScroll = () => {
        const element = document.getElementById(sectionId);
        if (element && attempts < maxAttempts) {
          scrollToSection();
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(tryScroll, 200);
        }
      };

      // Start trying after a short delay
      setTimeout(tryScroll, 300);
    }
  }, []);

  return (
    <HomeContainer>
      <Hero />
      <ClientLogos />
      <Services />
      <FundingTeaser />
      <Projects />
      <About />
      <Contact />
    </HomeContainer>
  );
};

export default Home; 